import { TOKEN_KEY } from '@/utils/constant'
import { post } from '@/plugins/request'
import { Message } from 'element-ui'
import store from '@/store/index'
import vue from 'vue'
console.log('vue===>', vue.prototype)

export const SetToken = async (token) => {
  window.sessionStorage.removeItem(TOKEN_KEY)
  // const result = await post(`/sso/validToken?token=${token}`, { token: token })
  // 不验证token，直接使用query传过来的token
  const result = { success: true, result: token }
  console.log('result===>', result)
  if (result?.success) {
    window.sessionStorage.setItem(TOKEN_KEY, result.result)
    // post('/orgPerson/v0.1/system/user/selectLoginUser').then(
    //   (res) => {
    //     store.commit('user/SET_USER', res?.result?.userInfo)
    //   },
    //   (err) => {
    //     Message({
    //       message: err,
    //       type: 'error',
    //       duration: 10000
    //     })
    //   }
    // )
  } else {
    Message({
      message: result.message,
      type: 'error',
      duration: 10000
    })
  }
}

export const GetToken = () => {
  // console.log(window.sessionStorage.getItem(TOKEN_KEY),'token')
  if (!store.state.user.uname && window.sessionStorage.getItem(TOKEN_KEY)) {
    // post('/orgPerson/v0.1/system/user/selectLoginUser').then(
    //   (res) => {
    //     store.commit('user/SET_USER', res?.result?.userInfo)
    //   },
    //   (err) => {
    //     Message({
    //       message: err,
    //       type: 'error',
    //       duration: 10000
    //     })
    //   }
    // )
  }
  return window.sessionStorage.getItem(TOKEN_KEY)
}
